import { create } from "zustand"

type PreorderWhyDialogStore = {
  open: boolean
  variantIds: string[]
  skuIds?: string[]
  dateRange?: { start: Date; end: Date }
  openDialog: (args: {
    variantIds: string[]
    skuIds?: string[]
    dateRange?: { start: Date; end: Date }
  }) => void
  closeDialog: () => void
}

export const usePreorderWhyDialogStore = create<PreorderWhyDialogStore>((set) => ({
  open: false,
  variantIds: [],
  skuIds: undefined,
  dateRange: undefined,
  openDialog: ({ variantIds, skuIds, dateRange }) =>
    set({ open: true, variantIds, skuIds, dateRange }),
  closeDialog: () => set({ open: false }),
}))
